import { SimpleSelect } from '../../../Select/SimpleSelect';
import { monthsNames } from '../../Datepicker.consts';
import { StyledRowOffset } from '@/shared/styles';
import { getAllYears } from '../../Datepicker.utils';
import { DatepickerHeaderProps } from './DatepickerHeader.consts';
import { useTranslation } from 'react-i18next';

export const DatepickerHeader: React.FC<DatepickerHeaderProps> = ({
  month,
  year,
  setMonth,
  setYear,
}: DatepickerHeaderProps) => {
  const { t } = useTranslation();

  return (
    <StyledRowOffset>
      <SimpleSelect
        className="select-month"
        label={t('admin.datepicker.select_month')}
        options={monthsNames.map((month, i) => ({ value: i + 1, label: month }))}
        value={monthsNames[month - 1]}
        onChange={(val) => {
          setMonth(Number(val));
        }}
      />
      <SimpleSelect
        className="select-year"
        label={t('admin.datepicker.select_year')}
        options={getAllYears().map((year) => ({ value: year, label: String(year) }))}
        value={String(year)}
        onChange={(val) => {
          setYear(Number(val));
        }}
      />
    </StyledRowOffset>
  );
};
